import React from 'react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const pains = ['Perdés todos los domingos buscando piezas y armando planificación que el lunes igual improvisás', 'Repertorio repetido y desordenado: cada alumno toca lo mismo y se aburre', 'El 60% de los alumnos abandona en el primer año y no sabés por qué', 'Recitales de fin de año organizados a las apuradas, con piezas que se caen en escena', 'No podés justificar un aumento de honorarios porque no tenés un sistema profesional visible', 'Las mismas correcciones técnicas improvisadas, sin método claro que respalde tu autoridad', 'Padres que comparan con otros profes y preguntan "¿cuándo va a tocar algo reconocible?"', 'Teoría aburrida que el alumno odia y que no se conecta con las piezas que toca'];
  return <section className="bg-navy-900 bg-grain py-24 relative border-t border-gold/10" data-id="element-128">
      <div className="container mx-auto px-6 content-relative" data-id="element-129">
        <FadeIn className="text-center max-w-3xl mx-auto mb-16" data-id="element-130">
          <h2 className="font-display font-bold text-2xl md:text-3xl text-white mb-4 leading-tight" data-id="element-131">
            Si sos profe de piano en Argentina,
            <br data-id="element-132" />
            <span className="text-gold" data-id="element-133">esto te va a sonar familiar:</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 max-w-5xl mx-auto mb-20" data-id="element-134">
          {pains.map((pain, i) => <FadeIn key={i} delay={0.1 * (i % 4)} direction="up" data-id="element-135">
              <div className="flex items-start gap-4 p-4 rounded-lg hover:bg-white/5 transition-colors" data-id="element-136">
                <span className="text-warning text-xl shrink-0 mt-1" data-id="element-137">❌</span>
                <p className="text-gray-200 text-base md:text-lg leading-relaxed" data-id="element-138">
                  {pain}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} className="text-center" data-id="element-139">
          <p className="font-display italic text-2xl md:text-3xl text-gold" data-id="element-140">
            "¿Cuántos domingos más vas a perder haciendo lo mismo?"
          </p>
        </FadeIn>
      </div>
    </section>;
}